import angular from 'angular';
import template from './placeholder-empty.html';
import './placeholder-empty.scss';
class PlaceholderEmptyController {
    constructor() { }
    $onInit() { }
}
const placeholderEmpty = {
    template,
    bindings: {
        text: '@',
        withTranslate: '<?',
    },
    controller: PlaceholderEmptyController,
};
export default angular
    .module('doxy.common.components.placeholderEmpty', [])
    // placeholder-empty
    .component('placeholderEmpty', placeholderEmpty).name;
